import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';

import store from '@/store';
import { IdentityDocument } from '@/api/identityDocuments';
import { getIdentityDocumentsNoticeRecovery } from '@/api/main';
import { ErrorAlertModule } from '@/store/modules/errors';
import { errorHandler } from '@/utils/common';

export interface IIdentityDocumentsNoticeRecoveryState {
  list: IdentityDocument[];
}

@Module({ dynamic: true, store, name: 'identityDocumentsNoticeRecovery' })
class IdentityDocumentsNoticeRecovery
  extends VuexModule
  implements IIdentityDocumentsNoticeRecoveryState {
  list: IdentityDocument[] = [];
  loaded = false;
  loading = false;

  @Mutation
  loadAllPending() {
    this.list = [];
    this.loading = true;
    this.loaded = false;
  }

  @Mutation
  loadAllFulfilled(data: IdentityDocument[]) {
    this.loading = false;
    this.loaded = true;
    this.list = data;
  }

  @Mutation
  loadAllRejected() {
    this.loading = false;
    this.loaded = false;
  }

  @Action
  async loadAllIdDocsNoticeRecovery() {
    ErrorAlertModule.setErrorAlert('');
    this.loadAllPending();

    try {
      const data = await getIdentityDocumentsNoticeRecovery();
      this.loadAllFulfilled(data);
    } catch (error) {
      this.loadAllRejected();
      errorHandler(error);
    }
  }
}

export const IdentityDocumentsNoticeRecoveryModule = getModule(
  IdentityDocumentsNoticeRecovery
);
